import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logoMark from "../../assets/brand/mark-primary.svg";

const Login = () => {
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(formData.email, formData.password);
    } catch (err) {
      console.error("Login error:", err);
      // The server sends a plain-string message (e.g. "Invalid password",
      // or "This account has been deactivated...") - fall back to a
      // generic one only if that's missing entirely (a network error, the
      // server being unreachable, etc).
      setError(
        typeof err.response?.data === "string"
          ? err.response.data
          : "Couldn't log in. Check your connection and try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-paper">
      <div className="bg-card border border-line p-8 rounded-lg w-96">
        <div className="flex items-center gap-2.5 mb-6">
          <img src={logoMark} alt="Ekhoni Khabo" className="w-9 h-9" />
          <span className="text-lg font-bold text-ink">Ekhoni Khabo</span>
        </div>
        <h2 className="text-xl font-semibold mb-4 text-ink">Log in</h2>

        {error && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-2 mb-4">
            {error}
          </p>
        )}

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="border border-line p-2 w-full mb-4 rounded focus:ring focus:ring-primary/30"
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            className="border border-line p-2 w-full mb-4 rounded focus:ring focus:ring-primary/30"
            required
          />
          <button
            type="submit"
            disabled={submitting}
            className="bg-primary text-white p-2 w-full rounded hover:opacity-90 transition disabled:opacity-60"
          >
            {submitting ? "Logging in…" : "Log in"}
          </button>
        </form>
        <Link
          to="/forgot-password"
          className="block text-center text-sm text-primary mt-4 hover:underline"
        >
          Forgot password?
        </Link>
      </div>
    </div>
  );
};

export default Login;
